import { __assign } from 'tslib';
import * as React from 'react';

// TODO: this SVG component should be replaced by Decorative shape once
// https://invitae.jira.com/browse/WT-19127 is implemented
var CurvedCropCornerShape = function (props) {
    return (React.createElement("svg", __assign({ height: "100%", id: "curvedCropCornerShape", width: "100%", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M0 238.468c119.333 35.688 232.03-6.086 338.092-125.323C386.597 58.615 452.566 20.9 536 0H0v238.468z", fill: "#2C6BAA", fillRule: "evenodd" })));
};

export { CurvedCropCornerShape as default };
//# sourceMappingURL=CurvedCropCornerShape.esm.js.map
